import { useEffect, useRef } from 'react';

// Custom @ovpn-ui events

// Window Event

// Element Event

// Document Event

function useEventListener(eventName, handler, element, options) {
  const savedHandler = useRef(handler);

  // Update ref.current value if handler changes.
  // This allows our effect below to always get latest handler
  // without us needing to pass it in effect deps array
  // and potentially cause effect to re-run every render.
  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);
  useEffect(() => {
    const targetElement = (element == null ? void 0 : element.current) || window;
    const isSupported = targetElement && targetElement.addEventListener;
    if (!isSupported) return;
    const eventListener = event => savedHandler.current(event);
    targetElement.addEventListener(eventName, eventListener, options);

    // eslint-disable-next-line consistent-return
    return () => {
      targetElement.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element, options]);
}
export default useEventListener;